
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo/[promo]",
      function () {
        return require("private-next-pages/promo/[promo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo/[promo]"])
      });
    }
  